import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#2a5a40]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Material de Aula',
    subtitle: 'Todo lo que necesitás para el primer día y para todo el año',
    desc: 'Presentación de la asignatura, historia de la topografía, conceptos fundamentales, sistemas de unidades y escalas, coordenadas, errores y tolerancias. Con secuencia didáctica, actividades participativas y material fotocopiable listo para entregar al alumno desde el día 1.',
    resuelve: 'El inicio del año suele ser caótico. Este tomo te da la estructura y los materiales listos para arrancar con autoridad y orden.',
    resultado: 'Tus alumnos comprenden los fundamentos teóricos con material claro y actividades que fijan los conceptos clave.',
    tags: ['CONCEPTOS', 'ESCALAS', 'ERRORES', 'ACTIVIDADES', 'FOTOCOPIABLE']
  }, {
    id: 2,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#2a5a40]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Guías de Práctica de Campo',
    subtitle: 'Salís al campo sin improvisar. Con protocolo, seguridad y evaluación incluida',
    desc: 'Guías completas paso a paso para cada práctica. Planillas de registro, instrucciones de seguridad, criterios de evaluación y variantes según el instrumental disponible. Listo para imprimir y repartir.',
    resuelve: 'Armar guías de campo lleva horas. Este tomo te da el paso a paso detallado para que la salida al campo sea segura y productiva.',
    resultado: 'Tus alumnos saben exactamente qué hacer en el campo, cómo registrar los datos y cómo serán evaluados.',
    tags: ['GUÍAS', 'CAMPO', 'PLANILLAS', 'SEGURIDAD', 'EVALUACIÓN']
  }, {
    id: 3,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#2a5a40]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Taller de Cálculo Planimétrico',
    subtitle: 'Que tus alumnos entiendan los números, no los copien',
    desc: 'Poligonal abierta y cerrada, métodos de compensación, cálculo de superficies, ejercicios resueltos y propuestos. Todo con secuencia didáctica progresiva y ejemplos reales de obra.',
    resuelve: 'El cálculo suele ser el punto débil. Este tomo lo hace progresivo y aplicado a casos reales para que no sea solo matemática abstracta.',
    resultado: 'Tus alumnos logran compensar poligonales y calcular superficies entendiendo el porqué de cada paso.',
    tags: ['POLIGONAL', 'COMPENSACIÓN', 'SUPERFICIES', 'EJERCICIOS', 'OBRA']
  }, {
    id: 4,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#2a5a40]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Laboratorio de Altimetría',
    subtitle: 'El tomo que transforma la nivelación de un tema temido en una clase dinámica',
    desc: 'Sistema de referencias altimétrico, nivelación geométrica, errores frecuentes, curvas de nivel, perfiles longitudinales y transversales, movimiento de tierras. Con guías de práctica y evaluaciones con clave.',
    resuelve: 'La altimetría requiere mucha visualización. Este tomo aporta los recursos para que los perfiles y el movimiento de tierras se entiendan fácilmente.',
    resultado: 'Tus alumnos dominan la nivelación y pueden interpretar y generar perfiles topográficos con precisión.',
    tags: ['NIVELACIÓN', 'CURVAS', 'PERFILES', 'MOVIMIENTO DE TIERRAS']
  }, {
    id: 5,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#2a5a40]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Módulo de Obra y GPS',
    subtitle: 'El puente entre el aula y la obra real que tus alumnos necesitan',
    desc: 'Rol del topógrafo en obra, simulacros de replanteo urbano y vial, GPS en el aula, práctica RTK, casos reales de error en obra. Todo con material proyectable y actividades que generan discusión en clase.',
    resuelve: 'Falta conexión con la realidad laboral. Este tomo trae los problemas y tecnologías de la obra directamente al aula.',
    resultado: 'Tus alumnos se preparan para los desafíos reales del replanteo y el uso de tecnología GNSS en el campo.',
    tags: ['OBRA', 'REPLANTEO', 'GPS', 'RTK', 'CASOS REALES']
  }, {
    id: 6,
    lightColor: 'bg-[#1a3d2c]/60',
    borderColor: 'border-[#2a5a40]/80',
    textColor: 'text-slate-200',
    emoji: '⭐',
    title: 'Topografía Digital',
    subtitle: 'El tomo que cierra el ciclo y te posiciona como el docente que enseña el futuro',
    desc: 'Cómo enseñar tecnología sin volverse obsoleto, laboratorio de informática topográfica, AutoCAD aplicado, Civil 3D, superficies y perfiles, procesamiento GNSS con RTKLIB, evaluación práctica en computadora.',
    resuelve: 'La topografía digital avanza rápido. Este tomo te da las herramientas para enseñar software de vanguardia sin tener que ser un experto en IT.',
    resultado: 'Tus alumnos aprenden a procesar datos y generar entregables digitales usando Civil 3D y herramientas actuales.',
    tags: ['CIVIL 3D', 'AUTOCAD', 'GNSS', 'SOFTWARE', 'DIGITAL'],
    badge: '⭐ EL MÁS POPULAR'
  }];
  const bonos = [{
    id: 1,
    title: 'Banco de Evaluaciones',
    valor: '$18.000 ARS',
    desc: '500 preguntas organizadas por tema, tipo y nivel. Con clave de corrección incluida. Verdadero/Falso, múltiple opción, cálculo, desarrollo. Modelos listos para imprimir.'
  }, {
    id: 2,
    title: 'Banco de Actividades Prácticas',
    valor: '$15.000 ARS',
    desc: '100 actividades listas para usar en aula, campo y laboratorio. Todas con objetivos, consignas, materiales necesarios y criterios de evaluación.'
  }, {
    id: 3,
    title: 'Plantillas Excel de Cálculo Topográfico',
    valor: '$12.000 ARS',
    desc: 'Las planillas que usás en clase, ya armadas y con fórmulas cargadas. Poligonal, nivelación, superficies, perfiles. El alumno carga datos y ve resultados.'
  }, {
    id: 4,
    title: 'Glosario Técnico Ilustrado',
    valor: '$10.000 ARS',
    desc: 'Términos topográficos con definición clara, imagen de referencia y ejemplo de uso en obra. Ideal para entregar al inicio del año como material de consulta.'
  }];
  return <section className="py-20 bg-[#0c241a]" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="text-center mb-16" data-id="element-160">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0a1f15]/80 text-slate-200 border border-[#2a5a40]/50 font-bold mb-6 text-[16px]" data-id="element-161">
            📐 LOS 6 TOMOS
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-162">
            Un tomo por cada dimensión de la enseñanza
          </h2>
          <p className="text-slate-300 font-medium text-[16px]" data-id="element-163">
            Todo el sistema didáctico resuelto para docentes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-164">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#1a3d2c] bg-[#06140d]/80 overflow-hidden shadow-lg hover:shadow-xl hover:border-[#2a5a40]/50 transition-all flex flex-col h-full relative" data-id="element-165">
              {tomo.badge && <div className="absolute top-0 right-0 bg-slate-200 text-slate-950 font-bold text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-166">
                  {tomo.badge}
                </div>}
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-167">
                <div className="text-3xl" data-id="element-168">{tomo.emoji}</div>
                <div data-id="element-169">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-170">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-171">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-172">
                <p className="font-semibold text-slate-300 mb-3 pb-3 border-b border-[#1a3d2c]" data-id="element-173">
                  {tomo.subtitle}
                </p>
                <p className="text-slate-300 text-sm leading-relaxed mb-4" data-id="element-174">
                  {tomo.desc}
                </p>
                <div className="bg-[#0c241a]/50 p-3 rounded-lg mb-4 border border-[#1a3d2c]/50" data-id="element-175">
                  <p className="text-xs text-slate-400 mb-1" data-id="element-176">
                    <strong data-id="element-177">¿Qué resuelve en el aula?</strong>
                  </p>
                  <p className="text-sm text-slate-300" data-id="element-178">{tomo.resuelve}</p>
                </div>
                <div className="bg-emerald-900/20 p-3 rounded-lg mb-4 border border-emerald-800/30" data-id="element-179">
                  <p className="text-xs text-emerald-300 mb-1" data-id="element-180">
                    <strong data-id="element-181">Resultado:</strong>
                  </p>
                  <p className="text-sm text-slate-200" data-id="element-182">{tomo.resultado}</p>
                </div>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-183">
                  {tomo.tags.map((tag, j) => <span key={j} className="text-[10px] font-bold uppercase tracking-wider bg-[#1a3d2c] text-slate-300 px-2 py-1 rounded" data-id="element-184">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-12 border-t border-[#1a3d2c] pt-16" data-id="element-185">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0a1f15]/80 text-slate-200 border border-[#2a5a40]/50 font-bold mb-6 text-[16px]" data-id="element-186">
            🎁 LOS 4 BONOS ESTRATÉGICOS
          </div>
          <h2 className="md:text-4xl font-extrabold text-white mb-4 text-[22px]" data-id="element-187">
            Siempre incluidos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-188">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#1a3d2c] bg-[#06140d]/80 p-6 flex flex-col h-full" data-id="element-189">
              <h4 className="font-bold text-slate-200 mb-2" data-id="element-190">BONO 0{bono.id}</h4>
              <h3 className="font-bold text-white text-lg mb-3" data-id="element-191">
                {bono.title}
              </h3>
              <p className="text-xs font-bold text-slate-400 mb-4 pb-3 border-b border-[#1a3d2c]" data-id="element-192">
                Valor real: <span className="line-through" data-id="element-193">{bono.valor}</span> →{' '}
                <span className="text-slate-200" data-id="element-194">GRATIS</span>
              </p>
              <p className="text-slate-300 text-sm leading-relaxed flex-grow" data-id="element-195">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-[#0a1f15]/50 rounded-2xl p-6 md:p-8 border border-[#2a5a40] text-center" data-id="element-196">
          <p className="text-slate-400 font-medium mb-2" data-id="element-197">
            Valor total de los 4 bonos: $55.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-198">
            Tu precio hoy: 🎁 GRATIS con tu Megapack
          </p>
        </motion.div>
      </div>
    </section>;
}